import React from 'react';
import { formatDate, formatHM, formatPeriod } from '../../utils/timesheet';
import { StatusPill } from './TimesheetParts';
import PeriodActions from './PeriodActions';

const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`;

/**
 * The sidebar card for the pay period on screen: what is logged, what is
 * missing or flagged, and whatever the server's `actions` allow (submit,
 * approve, return, reopen).
 */
export default function PeriodCard({
  period,
  status,
  seconds,
  billableSeconds,
  missingDays,
  issueCount,
  failCount,
  onShowIssue = null,
  actions,
  onAction,
}) {
  const closed = status === 'approved';
  const missing = missingDays.slice(0, 2).map((d) => formatDate(d, { weekday: 'short', month: 'short', day: 'numeric' }));

  return (
    <section className="ts-side-card" aria-labelledby="ts-period-title">
      <div className="ts-side-card__head">
        <h2 id="ts-period-title" className="ts-side-card__title">Pay period</h2>
        <StatusPill status={status} />
      </div>
      <span className="ts-side-card__sub">{formatPeriod(period)}</span>
      <span className="ts-period-card__total">{formatHM(seconds)}</span>

      <ul className="ts-period-card__facts">
        <li><span>Billable</span><strong>{formatHM(billableSeconds)}</strong></li>
        {!closed ? (
          <li>
            <span>Empty weekdays</span>
            <strong className={missingDays.length ? 'ts-text-warn' : undefined}>
              {missingDays.length ? `${missingDays.length} · ${missing.join(', ')}${missingDays.length > 2 ? '…' : ''}` : 'None'}
            </strong>
          </li>
        ) : null}
        {!closed ? (
          <li>
            <span>Checks flagged</span>
            {issueCount && onShowIssue ? (
              <button
                type="button"
                className={`ts-period-card__issues ${failCount ? 'bdc-text-bad' : 'ts-text-warn'}`}
                onClick={onShowIssue}
                title="Go to the first one"
              >
                {plural(issueCount, 'check')}
              </button>
            ) : (
              <strong className={issueCount ? (failCount ? 'bdc-text-bad' : 'ts-text-warn') : undefined}>
                {issueCount ? plural(issueCount, 'check') : 'None'}
              </strong>
            )}
          </li>
        ) : null}
      </ul>

      <PeriodActions actions={actions} onAction={onAction} />
    </section>
  );
}
